import TabButton from "../../components/atoms/buttons/TabButton";

function UserSettingsTab({ currentStep, handleSetFormStep, isOnboard }: any) {
  return (
    <div>
      <span className="xxl:text-5xl mb-2 font-sora text-xl font-semibold text-white xl:text-3xl">
        {isOnboard ? "Profile Settings" : "Create Your Account"}
      </span>
      <div className="xxl:text my-3 flex space-x-4 text-base font-semibold xl:text-xs ">
        <TabButton
          label="PERSONAL INFO"
          isActive={currentStep === 0}
          handleOnClick={() => {
            if (isOnboard) return handleSetFormStep("0", true);
            return null;
          }}
        />
        {isOnboard && (
          <TabButton label="ADDRESS" isActive={currentStep === 1} handleOnClick={() => handleSetFormStep("1", true)} />
        )}
        <TabButton label="SECURITY" isActive={currentStep === 2} handleOnClick={() => handleSetFormStep("2", true)} />
      </div>
    </div>
  );
}
export default UserSettingsTab;
